import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <div>
                &copy; 2023 Cameron Cunning
            </div>
        )
    }
}
